import { api } from 'api'

let pusherInstance = null

export const CHANNELS = {
  ACCOUNT_DATASET_SUBMISSION_CHANGES: {
    type: 'private',
    name: (accountId, userId) =>
      `private-ACCOUNT_DATASET_SUBMISSION_CHANGES.a_${accountId}.u_${userId}`,
    events: {
      DATASET_SUBMISSION_PHASE_CHANGED: 'DATASET_SUBMISSION_PHASE_CHANGED',
      DATASET_SUBMISSION_CREATED: 'DATASET_SUBMISSION_CREATED',
    },
  },
  ACCOUNT_DATASET_SUBMISSION_CHANGES_SINGLE: {
    type: 'private',
    name: (accountId, datasetSubmissionId) =>
      `private-ACCOUNT_DATASET_SUBMISSION_CHANGES_SINGLE.a_${accountId}.dss_${datasetSubmissionId}`,
    events: {
      DATASET_SUBMISSION_LOG_EVENT_ADDED: 'DATASET_SUBMISSION_LOG_EVENT_ADDED',
    },
  },
  ACCOUNT_DATASET_POST_CHANGES: {
    type: 'private',
    name: (accountId, datasetId) =>
      `private-ACCOUNT_DATASET_POST_CHANGES.a_${accountId}.ds_${datasetId}`,
    events: {
      EVENT_DATASET_POST_CHECKED: 'EVENT_DATASET_POST_CHECKED',
    },
  },
}

export async function initPusher(config) {
  if (pusherInstance) {
    return pusherInstance
  }

  const Pusher = await import('pusher-js')

  pusherInstance = new Pusher.default(config.appKey, {
    cluster: config.cluster,
    forceTLS: config.forceTLS,
    authorizer: channel => ({
      authorize: (socketId, callback) => {
        api
          .post('/broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then(response => {
            callback(false, response.data)
          })
          .catch(error => {
            callback(true, error)
          })
      },
    }),
  })

  return pusherInstance
}

export function getPusherInstance() {
  return pusherInstance
}
